<mat-card>
  <form [formGroup]="searchForm">
    <div class="row" style="display:flex !important;flex-wrap: wrap !important;">
      <div class="col-4" style="width:40%;padding:5px">
        <mat-form-field appearance="outline">
          <mat-label>{{entityNameLabel}}</mat-label>
          <mat-select formControlName="entityControl" name="entityControl" (selectionChange)="entityChange($event)">
            <mat-option *ngFor="let entity of entities" [value]="entity.entityID">
              {{entity.entityName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6"  style="width:40%;padding:5px">
        <mat-form-field appearance="standard">
          <mat-label>Filter</mat-label>
          <input matInput formControlName="search" (keyup)="applyFilter($event)" placeholder="Search" #input>
        </mat-form-field>
      </div>
      <div class="col-2 mt-3 text-right"  style="width:20%;padding:5px;text-align: right;margin-top: 15px;">
        <button mat-raised-button color="primary" (click)="ExportTOExcel()" [disabled]="exportDisabled">Export as
          Excel</button>
      </div>
    </div>

    <!-- Advanced Filters -->
    <mat-accordion class="" multi>
      <mat-expansion-panel (opened)="filterOpen($event)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Advanced Filter
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row" style="display:flex !important;flex-wrap: wrap !important;">

          <div class="col" style="width:17%;padding:10px;" *ngFor="let field of entityFields; let i=index">
            <!-- <mat-form-field> -->
            <mat-label>{{field.entityFieldName}}</mat-label>
            <ng-container *ngIf="field.questionMasters.inputType == 'dte'">
              <mat-form-field>
                <input matInput  [matDatepicker]="picker" id="{{field.questionMasters.questionId}}" name="dateField">
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <!-- <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon> -->
                  <fa-icon [icon]="faDatePicker"></fa-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <!-- <input matInput [matDatepicker]="picker" id="{{field.questionMasters.questionId}}" name="dateField">
                <mat-datepicker-toggle matSuffix [for]="picker" class="padding-left-90">
                  <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon> -->
              <!-- </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker> -->
            </ng-container>
            <ng-container *ngIf="field.questionMasters.inputType != 'dte'">
              <mat-form-field>
                <input matInput id="{{field.questionMasters.questionId}}">
              </mat-form-field>
            </ng-container>


          </div>
          <!-- <div>
          <button mat-raised-button color="primary" (click)="ExportTOExcel()">Export as Excel</button></div> -->
          <div *ngIf="!isFilterPresent">
            <div class="d-flex justify-content-center">No Advanced Filters set</div>
          </div>

        </div>
        <mat-action-row class="pr-4">
          <button mat-raised-button color="primary" [disabled]="!isFilterPresent"
            (click)="applyFilters($event)">Apply</button>
          <button mat-raised-button [disabled]="!isFilterPresent" (click)="resetFilters($event)">Reset</button>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
    <br>
    <!-- Advanced Filters End-->
    <div #TABLE *ngIf="dataSource">
      <div *ngIf="dataSource.data.length">
        <table mat-table #table [dataSource]="dataSource" class="mat-elevation-z8" matSort aria-describedby="Entity search result">
          <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index" matColumnDef="{{disCol}}">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{disCol}}</th>
            <td mat-cell *matCellDef="let element ">
              {{element[disCol]}}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


          <!-- <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
        </tr> -->
          <!-- <ng-container *ngIf="dataSource.data.length === 0">
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No records found</td>
          </tr>
        </ng-container> -->
          <!-- <div *ngIf="dataSource.data.length === 0">No records found</div> -->
        </table>
        <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of Survey">
        </mat-paginator>
      </div>
      <div *ngIf="!dataSource.data.length">
        No records found
      </div>
    </div>
  </form>
</mat-card>